/* eslint-disable no-nested-ternary */
import { Input, InputAdornment, Popper } from "@material-ui/core";
import clsx from "clsx";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import { useRouter } from "next/router";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useWindowResize } from "utils/hooks";

function SearchInput(
	{
		icon,
		closeIcon,
		placeholders,
		children,
		value,
		setValue,
		selectInputOnFocus,
		fullWidth,
		handleSelect = (val) => null,
		clearable = null,
		showRightBorder = false,
		searchBoxRef,
		fromHomePage,
		mixPanelEventType,
		emptyCaseDefaultValue = null,
		appliedFilterCount = null,
		handleChange = (val) => {},
		showSearchList = true,
		handleClear = () => null,
		isUserLoggedIn = false,
		isQuery = false,
		testId,
	},
	ref
) {
	const [isOpen, setIsOpen] = useState(false);
	const [placeHolderIndex, setPlaceHolderIndex] = useState(0);
	const anchorRef = useRef(null);
	const [isMobileView] = useWindowResize();
	const router = useRouter();

	const handleKeyUp = (e) => {
		if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
			const navigationItems =
				document.getElementById("js-navigation-parent")?.children;

			const activeIndex = Array.from(navigationItems).findIndex((item) =>
				item.classList.contains("active")
			);

			if (e.keyCode === 13) {
				if (activeIndex >= 0) {
					navigationItems[activeIndex]?.click();
				} else {
					handleSelect(e.target.value);
				}
			} else {
				const nextIndex =
					e.keyCode === 38
						? (activeIndex - 1 + navigationItems.length) %
						  navigationItems.length
						: (activeIndex + 1) % navigationItems.length;

				Array.from(navigationItems).forEach((item, index) => {
					if (nextIndex === index) {
						item.classList.add("active");
					} else {
						item.classList.remove("active");
					}
				});
			}
		}
	};

	useEffect(() => {
		if (placeholders.length > 1) {
			const timer = setInterval(() => {
				setPlaceHolderIndex(
					(placeHolderIndex) => (placeHolderIndex + 1) % placeholders.length
				);
			}, 2000);

			return () => {
				clearInterval(timer);
			};
		}
	}, [placeholders]);

	// useEffect(() => {
	// 	if (!showSearchList) {
	// 		setIsOpen(false);
	// 	}
	// }, [showSearchList]);
	const trackMixpanelEvent = () => {
		const isSearch = router.query?.search;
		trackOnMixpanel("Search Bar Clicked Web", {
			Job_Search_Ingress: fromHomePage
				? "Home Page"
				: isSearch || appliedFilterCount
				? "Fetched Results"
				: "Job Listing Page",
			Section: mixPanelEventType,
		});
	};
	return (
		<div
			ref={anchorRef}
			className={clsx(
				"flex w-full items-center rounded-[8px] border-[1px] p-[8px] md:rounded-none md:border-0 md:border-b-0 md:border-[#D1CED4] md:p-0 md:pr-4",
				{
					"bg-[#F4F2F6]": isMobileView,
					"md:border-r": showRightBorder,
					"w-[398px]": isMobileView && fromHomePage,
				}
			)}
		>
			<StyledInput
				data-testid={testId}
				inputRef={ref}
				fullWidth
				value={value}
				onChange={(e) => {
					setIsOpen(true);
					setValue(e.target.value);
				}}
				onKeyUp={handleKeyUp}
				onFocus={() => {
					if (!isUserLoggedIn && !isMobileView && isQuery && !value) {
						setIsOpen(false);
					} else {
						setIsOpen(true);
						selectInputOnFocus();
						trackMixpanelEvent();
						if (clearable === value) {
							setValue("");
						}
					}
				}}
				onBlur={(e) => {
					document.body.style.overflow = "auto";
					e.target.style.fontWeight = "Normal";
					if (isMobileView) {
						anchorRef.current.style.background = "#F4F2F6";
					} else if (!fromHomePage) {
						searchBoxRef.current.style.background = "#F4F2F6";
						searchBoxRef.current.style.border = "none";
					}
					setIsOpen(false);
					setTimeout(() => {
						if (!e.target.value) {
							setValue(emptyCaseDefaultValue?.display_name);
							handleChange(emptyCaseDefaultValue);
						} else if (isMobileView) {
							handleSelect(e.target.value);
						}
					}, 10);
				}}
				type="text"
				aria-label={placeholders[placeHolderIndex]}
				placeholder={placeholders[placeHolderIndex]}
				disableUnderline
				className="mediumPlaceholder grow outline-none"
				startAdornment={<InputAdornment position="start">{icon}</InputAdornment>}
				endAdornment={
					value && isOpen ? (
						<InputAdornment
							position="start"
							className="cursor-pointer pl-[8px]"
							onClick={() => {
								handleClear();
							}}
							onMouseDown={() => handleClear()}
						>
							{closeIcon}
						</InputAdornment>
					) : (
						<></>
					)
				}
			/>

			{!isMobileView && (
				<Popper
					anchorEl={anchorRef.current}
					open={isOpen}
					modifiers={{
						offset: {
							enabled: true,
							offset: "0,30",
						},
					}}
					className={`z-[1000] max-h-[200px] ${
						fullWidth ? "w-[420px]" : "w-[300px]"
					} max-w-[400px] overflow-y-auto !rounded-[8px] bg-white shadow-200`}
					placement="bottom-start"
				>
					<div className="flex w-[100vw] flex-col gap-3 bg-white py-[16px] md:w-full md:rounded-[8px]">
						{children}
					</div>
				</Popper>
			)}
		</div>
	);
}

export default forwardRef(SearchInput);

const StyledInput = styled(Input)`
	.MuiInputBase-input {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		font-family: Inter;
		::placeholder {
			font-weight: normal !important;
			color: #8c8594;
			opacity: 1;
			font-size: 16px;
			line-height: 24px;
		}
	}
`;
